import { notification } from "ant-design-vue"
import { h } from "vue"

import { getCompanyProblem } from "@/components/Companies/companyArchiving"
import { i18n } from "@/i18n"

export const showArchivedCompanyError = (error, tenantId) => {
  const problem = getCompanyProblem(error)
  if (problem?.code !== "company_archived") return false
  const base = (process.env.BASE_URL || "/").replace(/\/$/, "")
  const href = `${base}/companies/archived?companyId=${encodeURIComponent(problem.companyId ?? "")}`
  notification.warning({
    key: `company-archived-${tenantId}-${problem.companyId}`,
    message: i18n.global.t("companies.archiving.newWorkBlocked"),
    description: h("div", [
      h("p", i18n.global.t("companies.archiving.newWorkRecovery")),
      h("a", { href, target: "_blank", rel: "noopener noreferrer" },
        i18n.global.t("companies.archiving.openArchiveInNewTab"))
    ]),
    duration: 0
  })
  error.companyArchiveHandled = true
  return true
}
